import * as Astronomy from 'astronomy-engine'

export function getAscendantSign(birthDate, birthTime, tzOffset, lat, lon) {
    const [day, month, year] = birthDate.split('.').map(Number)
    const [hour, minute]     = birthTime.split(':').map(Number)
    const date = new Date(year, month - 1, day, hour, minute)
    const time = new Astronomy.AstroTime(date)

    const lst    = Astronomy.SiderealTime(time, lon)
    const eps    = 23.437
    const phi    = lat * (Math.PI / 180)
    const lstRad = (lst * 15) * (Math.PI / 180)
    const epsRad = eps * (Math.PI / 180)

    const ascRad   = Math.atan2(Math.cos(lstRad), -Math.sin(lstRad) * Math.cos(epsRad) - Math.tan(phi) * Math.sin(epsRad))
    const ascDegree = (ascRad * 180 / Math.PI + 360) % 360

    const signs = [
        "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo",
        "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"
    ]
    return signs[Math.floor(ascDegree / 30)]
}
